export const SET_CANVAS_TOOLBAR_STATE = 'SET_CANVAS_TOOLBAR_STATE'
export const setCanvasToolbarState = (payload) => ({
    type: SET_CANVAS_TOOLBAR_STATE,
    payload
})
